import type { DrillDownInfo, MeasureDrillDownInfo } from "../../../../../../../../api/types/svTypes";
import { type DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import IrrPage from "./irr/IrrPage";
import { isIrrDrillDownInfo, isMeasureDrillDownInfo, isMetricDrillDownInfo } from "./isMeasureDrillDownInfo";
import { getExtensionLedger } from "./ledger/extensionLedgers";
import LedgerPage from "./ledger/LedgerPage";
import MainPage from "./MainPage";
import PmPage from "./pm/PmPage";

interface Props {
  configuration: DrillDownPage;
  info: DrillDownInfo;
}
const DrillDownWrapper = ({ configuration, info }: Props) => {
  const irrInfo = isIrrDrillDownInfo(info.combined);

  if (irrInfo) {
    return <IrrPage configuration={configuration} drillDownInfo={info} />;
  }
  if (isMetricDrillDownInfo(info.combined)) {
    return <PmPage configuration={configuration} info={info.combined} />;
  }
  if (isMeasureDrillDownInfo(info.combined) && getExtensionLedger(info.combined.table) !== undefined) {
    return <LedgerPage configuration={configuration} info={info.combined} />;
  }
  if (configuration.onlyLedger) {
    return <LedgerPage configuration={configuration} info={info.combined as MeasureDrillDownInfo} />;
  }
  return <MainPage configuration={configuration} info={info} />;
};

export default DrillDownWrapper;
